import { registerQuery, useQuery } from 'data-fetching-client';
import apiClient from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const PortalDetailsQuery = registerQuery({
  fieldName: 'portalDetails',
  args: [],
  fetcher: () => {
    return apiClient.get(`hubs/v1/hubs/${PortalIdParser.get()}`);
  }
});
export const useFetchPortalDetails = () => {
  const {
    data,
    loading,
    error
  } = useQuery(PortalDetailsQuery);
  return {
    data: data === null || data === void 0 ? void 0 : data.portalDetails,
    loading,
    error
  };
};